import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const ErrorIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      {/* Box Icons - Copyright (c) 2015-2021 Aniket Suvarna */}
      <path
        fill="currentColor"
        d="M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A1 1 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467zM13 18h-2v-2h2zm-2-4V9h2l.001 5z"
      />
    </IconBase>
  );
};

export default ErrorIcon;
